export const regions = [
    {
      name: "All Regions",
      location: null, // No specific location for All Regions
    },
    {
      name: "Sydney",
      location: {
        postcode: "",
        latitude: -33.8727409,
        longitude: 151.2057136,
        address: "Sydney NSW, Australia",
        city: "Sydney",
        country: "Australia",
      },
    },
    {
      name: "Melbourne",
      location: {
        postcode: "",
        latitude: -37.8136276,
        longitude: 144.9630576,
        address: "Melbourne VIC, Australia",
        city: "Melbourne",
        country: "Australia",
      },
    },
    {
      name: "Brisbane",
      location: {
        postcode: "",
        latitude: -27.4704528,
        longitude: 153.0260341,
        address: "Brisbane QLD, Australia",
        city: "Brisbane",
        country: "Australia",
      },
    },
  ];